import styled from 'styled-components'

export const CalculatorContainer = styled.div`
  display: flex;
  
  @media all and (max-width: 990px) {
    flex-direction: column;
  }
`

export const Calculator = styled.div`
  flex: 1;
  margin-right: 2rem;
  
  @media all and (max-width: 990px) {
    margin: 0;
  }
`

export const Information = styled.div`
  flex: 2;
  @media all and (max-width: 990px) {
    flex: 1;
  }
`

export const SelectRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -.5rem 0;
`

export const Result = styled.strong`
  color: #f00;
  font-size: 2rem;
  margin-left: 1rem;
`

export const Smaller = styled.span`
  font-size: .7rem;
  color: #555;
`
